"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardsInformationModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var atomic_ui_lib_lts_1 = require("@greatmindsorg/atomic-ui-lib-lts");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var api_1 = require("../../../api");
var assets_1 = require("../../../assets");
var Common_1 = require("../../Common");
var StandardsInformationModal_styled_1 = require("./StandardsInformationModal.styled");
var image_1 = __importDefault(require("next/image"));
var StandardsInformationModal = function (_a) {
    var _b = _a.show, show = _b === void 0 ? true : _b, closeModal = _a.closeModal, standards = _a.standards, curriculumID = _a.curriculumID, assessmentTemplateId = _a.assessmentTemplateId, schoolYear = _a.schoolYear, _c = _a.itemStandards, itemStandards = _c === void 0 ? [] : _c, _d = _a.itemExternalId, itemExternalId = _d === void 0 ? '' : _d, _e = _a.isAvr, isAvr = _e === void 0 ? false : _e;
    var _f = (0, react_1.useState)(false), initialized = _f[0], setInitialize = _f[1];
    var _g = (0, react_1.useState)(), itemStandardsDictionary = _g[0], setItemStandardsDictionary = _g[1];
    var _h = (0, react_1.useState)([]), modalData = _h[0], setModalData = _h[1];
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var primaryText = t('standardsInformationModal.emptyData.primaryText');
    var secondaryText = t('standardsInformationModal.emptyData.secondaryText');
    var _j = (0, react_1.useContext)(api_1.ServiceContext), avrReportsService = _j.avrReportsService, standardService = _j.standardService;
    var toast = (0, react_1.useContext)(Common_1.AtomicAlertManagerContext).toast;
    var checkStandardsExist = function () {
        var standardPresent = standards.filter(function (standardCode) {
            return itemStandardsDictionary ? itemStandardsDictionary[standardCode] : false;
        });
        return standardPresent.length >= standards.length;
    };
    var callForNonAvr = function () {
        var _a;
        var filteredItemStandards = itemExternalId
            ? itemStandards.filter(function (i) { return i.externalItemId === itemExternalId; })
            : itemStandards;
        if (filteredItemStandards.length) {
            return standardService
                .findByGlobalId((_a = filteredItemStandards[0].standardGlobalIds) !== null && _a !== void 0 ? _a : [], {
                ancestors: true,
                children: false,
                examples: false,
            })
                .then(function (standardsResponse) {
                if (standardsResponse.length) {
                    var convertedStandards_1 = [];
                    standardsResponse.forEach(function (standardInfo) {
                        var _a, _b, _c;
                        if (standardInfo.ancestors) {
                            if (curriculumID === api_1.CurriculumId.EurekaMath) {
                                convertedStandards_1.push({
                                    itemExternalId: itemExternalId,
                                    standardSetGlobalId: '',
                                    standardCode: standardInfo.shortCode,
                                    desStandard: standardInfo.description,
                                    hierarchyLevel0: '',
                                    desItemlevel0: (_a = standardInfo.ancestors.find(function (i) { return i.hierarchyLevel === api_1.StandardHierarchyLevel.Domain; })) === null || _a === void 0 ? void 0 : _a.description,
                                    hierarchyLevel1: '',
                                    desItemlevel1: (_b = standardInfo.ancestors.find(function (i) { return i.hierarchyLevel === api_1.StandardHierarchyLevel.Cluster; })) === null || _b === void 0 ? void 0 : _b.description,
                                    hierarchyLevel2: '',
                                    desItemlevel2: '',
                                });
                            }
                            else if (curriculumID === api_1.CurriculumId.EurekaMathTX) {
                                convertedStandards_1.push({
                                    itemExternalId: itemExternalId,
                                    standardSetGlobalId: '',
                                    standardCode: standardInfo.shortCode,
                                    desStandard: '',
                                    hierarchyLevel0: '',
                                    desItemlevel0: (_c = standardInfo.ancestors.find(function (i) { return i.hierarchyLevel === api_1.StandardHierarchyLevel.Strand; })) === null || _c === void 0 ? void 0 : _c.description,
                                    hierarchyLevel1: '',
                                    desItemlevel1: standardInfo.description,
                                    hierarchyLevel2: '',
                                    desItemlevel2: '',
                                });
                            }
                        }
                    });
                    var itemStdDict_1 = setCopyItemDictionary(convertedStandards_1);
                    var itemStdInfo = standards.map(function (standardCode) { return itemStdDict_1[standardCode]; });
                    setModalData(itemStdInfo);
                }
            });
        }
        return Promise.reject();
    };
    var useV2 = (0, react_1.useMemo)(function () { var _a; return ((_a = (0, api_1.getObjectFromLocalStorage)(api_1.LocalStorageKeys.AffirmFeatureFlags)) === null || _a === void 0 ? void 0 : _a.AffirmAvrV2) || false; }, []);
    var callForAvr = function () {
        return avrReportsService
            .getSummaryReportItemStandards(curriculumID, assessmentTemplateId, schoolYear, useV2)
            .then(function (itemStandardsData) {
            var itemStdDict = setCopyItemDictionary(itemStandardsData);
            var itemStdInfo = standards.map(function (standardCode) { return itemStdDict[standardCode]; });
            setModalData(itemStdInfo);
        });
    };
    (0, react_1.useEffect)(function () {
        if (show) {
            setInitialize(false);
            if (checkStandardsExist()) {
                var standardsList = standards.map(function (standard) { return itemStandardsDictionary[standard]; });
                setModalData(standardsList);
                setInitialize(true);
            }
            else {
                var apiCall = isAvr ? callForAvr : callForNonAvr;
                apiCall()
                    .catch(function () {
                    toast({
                        alertVariant: 'error',
                        content: {
                            title: t('errorMessages.oopsErr'),
                            message: t('errorMessages.standardsData'),
                        },
                    });
                })
                    .finally(function () {
                    setInitialize(true);
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);
    var setCopyItemDictionary = function (itemStandardsData) {
        var copyItemStandardsDictionary = __assign({}, itemStandardsDictionary);
        itemStandardsData.map(function (item) {
            copyItemStandardsDictionary[item.standardCode] = item;
            return copyItemStandardsDictionary[item.standardCode];
        });
        setItemStandardsDictionary(copyItemStandardsDictionary);
        return copyItemStandardsDictionary;
    };
    return ((0, jsx_runtime_1.jsxs)(StandardsInformationModal_styled_1.StyledStandardsInformationModal, { show: show, onHide: closeModal, size: "lg", scrollable: true, "aria-labelledby": "standards-modal-title", curriculum: curriculumID, children: [(0, jsx_runtime_1.jsx)(Common_1.DpModal.Header, { children: (0, jsx_runtime_1.jsx)("div", { className: "title", children: (0, jsx_runtime_1.jsx)("div", { className: "assessment-title", children: (0, jsx_runtime_1.jsx)("h1", { className: "h3", id: "standards-modal-title", children: t('standardsInformationModal.heading', {
                                standardsName: standards.join(', '),
                            }) }) }) }) }), (0, jsx_runtime_1.jsx)(Common_1.DpModal.Body, { children: initialized ? (modalData.length && modalData[0] ? (modalData.map(function (item, index) { return ((0, jsx_runtime_1.jsxs)("div", { className: "content", children: [index > 0 && (0, jsx_runtime_1.jsx)("hr", {}), (0, jsx_runtime_1.jsx)("div", { className: "table-wrapper mb-3", children: (0, jsx_runtime_1.jsxs)("table", { children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { role: "row", children: [(0, jsx_runtime_1.jsx)("th", { role: "columnheader", scope: "col", children: t('standardsInformationModal.code') }), (0, jsx_runtime_1.jsx)("th", { role: "columnheader", scope: "col", children: api_1.CurriculumId.EurekaMath === curriculumID
                                                        ? t('standardsInformationModal.domain')
                                                        : t('standardsInformationModal.strand') }), api_1.CurriculumId.EurekaMath === curriculumID ? ((0, jsx_runtime_1.jsx)("th", { role: "columnheader", scope: "col", children: t('standardsInformationModal.cluster') })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}))] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: (0, jsx_runtime_1.jsxs)("tr", { role: "row", children: [(0, jsx_runtime_1.jsx)("td", { role: "cell", children: item.standardCode }), (0, jsx_runtime_1.jsx)("td", { role: "cell", children: (0, jsx_runtime_1.jsx)("span", { children: item.desItemlevel0 }) }), api_1.CurriculumId.EurekaMath === curriculumID ? ((0, jsx_runtime_1.jsx)("td", { role: "cell", children: item.desItemlevel1 })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}))] }) })] }) }), (0, jsx_runtime_1.jsxs)("div", { className: "mb-3", children: [(0, jsx_runtime_1.jsx)("h2", { className: "h3 description-title", "aria-label": api_1.CurriculumId.EurekaMath === curriculumID
                                        ? t('standardsInformationModal.ariaLabel.description', {
                                            standardName: item.standardCode,
                                        })
                                        : t('standardsInformationModal.ariaLabel.teks', {
                                            standardName: item.standardCode,
                                        }), children: api_1.CurriculumId.EurekaMath === curriculumID
                                        ? t('standardsInformationModal.description')
                                        : t('standardsInformationModal.teks') }), (0, jsx_runtime_1.jsx)("p", { className: "description", children: api_1.CurriculumId.EurekaMath === curriculumID
                                        ? item.desStandard
                                        : item.desItemlevel1 })] })] }, item.standardCode)); })) : ((0, jsx_runtime_1.jsxs)("div", { className: "empty-data-modal", children: [(0, jsx_runtime_1.jsx)(image_1.default, { alt: "Magnifier glass", className: "empty-state-image", src: assets_1.SvgImages.emptyStateGlass, width: 140, height: 142 }), (0, jsx_runtime_1.jsx)("h2", { className: "primary-text", children: primaryText }), (0, jsx_runtime_1.jsx)("div", { children: secondaryText })] }))) : ((0, jsx_runtime_1.jsx)(Common_1.Spinner, { className: "spinner override-color", size: atomic_ui_lib_lts_1.SpinnerSize.medium, ariaLabel: t('standardsInformationModal.ariaLabel.fetchingInformation') })) })] }));
};
exports.StandardsInformationModal = StandardsInformationModal;
exports.default = exports.StandardsInformationModal;
